// Mirrors backend/utils/certificateId.js; keep the two in sync.
export const CERTIFICATE_ID_MAX_LENGTH = 100;
export const CERTIFICATE_ID_ALLOWED_PATTERN = /^[A-Za-z0-9 /._-]+$/;
export const CERTIFICATE_ID_HINT =
  'Use letters, numbers, spaces, forward slashes (/), hyphens (-), dots (.) or underscores (_)';

export const validateCertificateId = (value) => {
  const trimmed = `${value ?? ''}`.trim();

  if (!trimmed) {
    return { isValid: false, value: '', error: 'Certificate ID is required' };
  }

  if (trimmed.length > CERTIFICATE_ID_MAX_LENGTH) {
    return {
      isValid: false,
      value: trimmed,
      error: `Certificate ID must be ${CERTIFICATE_ID_MAX_LENGTH} characters or fewer`
    };
  }

  if (!CERTIFICATE_ID_ALLOWED_PATTERN.test(trimmed)) {
    return { isValid: false, value: trimmed, error: CERTIFICATE_ID_HINT };
  }

  if (!/[A-Za-z0-9]/.test(trimmed)) {
    return {
      isValid: false,
      value: trimmed,
      error: 'Certificate ID must include at least one letter or number'
    };
  }

  return { isValid: true, value: trimmed, error: null };
};
